import { useEffect, useRef, useState } from "react";

/***
 * Custom hook for horizontal scroll
 */
export const useHorizontalScroll = () => {
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const [isDrag, setIsDrag] = useState(false);
  const [carouselIsMove, setCarouselIsMove] = useState(false);
  const [carouselNext, setCarouselNext] = useState(false);

  const scrollContainerRef = useRef(null);
  const timeoutRef = useRef(null);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const onMouseLeave = () => {
    setIsDragging(false);
  };

  const onMouseDown = (e) => {
    const touchX = e.changedTouches ? e.changedTouches[0]?.clientX : 0;
    const pageX = e.pageX || touchX;
    setIsDragging(true);
    setStartX(pageX - scrollContainerRef.current.offsetLeft);
    setScrollLeft(scrollContainerRef.current.scrollLeft);
  };

  const onMouseUp = (e) => {
    const touchX = e.changedTouches ? e.changedTouches[0]?.clientX : 0;
    const pageX = e.pageX || touchX;
    const subtraction = Math.abs(pageX - startX);
    setCarouselIsMove(subtraction >= 150);
    setCarouselNext(pageX < startX);
    setIsDragging(false);
    // @ts-ignore
    timeoutRef.current = setTimeout(() => {
      setIsDrag(false);
    }, 100);
  };

  const onMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - scrollContainerRef.current.offsetLeft;
    const walk = x - startX;
    scrollContainerRef.current.scrollLeft = scrollLeft - walk;

    if (Math.abs(walk) > 5) {
      setIsDrag(true);
    }
  };
  const onDragStart = (e) => {
    e.preventDefault();
    return false;
  };

  return {
    scrollContainerRef,
    isDrag,
    carouselIsMove,
    carouselNext,
    setCarouselIsMove,
    setCarouselNext,
    onMouseDown,
    onMouseMove,
    onMouseUp,
    onMouseLeave,
    onDragStart,
  };
};
